import { render, staticRenderFns } from "./polling.vue?vue&type=template&id=10a99a0e&"
import script from "./polling.vue?vue&type=script&lang=js&"
export * from "./polling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports